import script from "./ShowMonitoraggioTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMonitoraggioTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ShowMonitoraggioTemplate.vue?vue&type=style&index=0&id=48f7f892&lang=css"

const __exports__ = script;

export default __exports__